import { Entypo, FontAwesome } from '@expo/vector-icons';
import { router, useFocusEffect } from 'expo-router';
import { useCallback } from 'react';
import { StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';
import { Badge } from 'react-native-paper';

import { useGetNotificationFeed } from '@/api/hooks/notificationsHooks';

interface Props {
  onPress?: () => void;
  style?: ViewStyle;
  iconColor?: string;
  size?: number;
  hitSlop?: number;
  variant?: 'default' | 'alternative';
}

const BellButton = ({ onPress, style, iconColor, size, hitSlop = 30, variant = 'default' }: Props) => {
  const { data, refetch } = useGetNotificationFeed({
    limit: 10
  });

  // FocusEffect to refetch data when we update something
  useFocusEffect(
    useCallback(() => {
      refetch();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  );

  const unreadNotifications = data?.pages
    .flatMap((page) => page.results)
    .filter((notification) => !notification.hasBeenRead).length;

  return (
    <TouchableOpacity
      onPress={onPress !== undefined ? onPress : () => router.navigate('/(app)/notifications')}
      style={style}
      hitSlop={{ top: hitSlop, bottom: hitSlop, left: hitSlop, right: hitSlop }}>
      <>
        {unreadNotifications !== undefined && unreadNotifications > 0 && (
          <Badge
            size={18}
            style={[
              styles.badge,
              {
                top: variant === 'default' ? -6 : -2,
                right: variant === 'default' ? -6 : -2
              }
            ]}>
            {unreadNotifications > 9 ? '+9' : unreadNotifications}
          </Badge>
        )}
        {variant === 'default' && (
          <FontAwesome
            name="bell-o"
            size={size ?? 24}
            color={iconColor ? iconColor : '#808080'}
            style={styles.notificationIcon}
          />
        )}
        {variant === 'alternative' && (
          <Entypo
            name="bell"
            size={size ?? 24}
            color={iconColor ? iconColor : '#808080'}
            style={styles.notificationIcon}
          />
        )}
      </>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  notificationIcon: {
    transform: [{ scaleX: -1 }],
    left: -1
  },

  badge: {
    zIndex: 99,
    backgroundColor: '#DC2626',
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
    position: 'absolute'
  }
});

export default BellButton;
